// Initials avatar — a small colored circle showing the first letter
// (or two) of a name. Used on cards to humanize the catalog without
// needing actual profile photos.

type Props = {
  name: string;
  size?: number;
  title?: string;
};

function initialsFor(name: string): string {
  const cleaned = name.trim();
  if (!cleaned) return "?";
  // SharePoint often returns "Last, First" — flip if so for better initials
  const parts = cleaned.includes(",")
    ? cleaned
        .split(",")
        .reverse()
        .join(" ")
        .trim()
        .split(/\s+/)
    : cleaned.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Deterministic hue from name so a given person always gets the same color.
function hueFor(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return h % 360;
}

export function Avatar({ name, size = 22, title }: Props) {
  const initials = initialsFor(name);
  const hue = hueFor(name);
  return (
    <span
      className="avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
        background: `hsl(${hue} 65% 88%)`,
        color: `hsl(${hue} 55% 28%)`,
      }}
      title={title ?? name}
      aria-hidden
    >
      {initials}
    </span>
  );
}
